import { Component, inject } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { UserPermissionsService } from "src/app/core/services/user-permissions.service";
import { UserRoleService } from "src/app/core/services/user-role.service";
import { BottomMenuItemComponent } from "./bottom-menu-item/bottom-menu-item.component";
import { BottomMenuSheetComponent } from "./bottom-menu-sheet/bottom-menu-sheet.component";

@Component({
	selector: "app-bottom-menu",
	imports: [BottomMenuItemComponent, RouterLink, RouterLinkActive, TranslatePipe],
	templateUrl: "./bottom-menu.component.html",
})
export class BottomMenuComponent {
	private bottomSheet = inject(MatBottomSheet);

	public userRole = inject(UserRoleService);
	public userPermissions = inject(UserPermissionsService);

	showMore(): void {
		this.bottomSheet.open(BottomMenuSheetComponent);
	}
}
